import type { PatientRerequisitionEligibility } from '@customTypes/patient';

export type ReanalysisOrderingOptions = {
  productIds: string[];
  campaignCode?: string;
};

export function getReanalysisOrderingOptions(
  eligibility: PatientRerequisitionEligibility | null | undefined,
): ReanalysisOrderingOptions {
  const reanalysisProducts = eligibility?.reanalysis_products ?? [];
  if (!reanalysisProducts.length) {
    return { productIds: [] };
  }

  return {
    productIds: reanalysisProducts.map(product => product.product_id),
  };
}

export function hasReanalysisOrderingOptions(
  eligibility: PatientRerequisitionEligibility | null | undefined,
): boolean {
  return getReanalysisOrderingOptions(eligibility).productIds.length > 0;
}
